import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-skiplinks' })
export class NavSkiplinkComponent {
	private skiplinks: HTMLElement;
	private skiplinksList: HTMLElement[];

	constructor(private element: HTMLElement) {
		this.skiplinks = this.element;
		this.skiplinksList = Array.from(this.element.querySelectorAll('.js-skiplinks-link'));

		this.handleAutoFocus();
	}

	handleAutoFocus() {
		this.skiplinksList.forEach(element => {
			element?.addEventListener('keydown', event => {
				if (event.key === 'Enter') {
					console.log('foc');
					element.focus();
				}
			});
		});
	}
}
